import { HttpInterceptorFn } from '@angular/common/http';
import { Auth } from '../services/auth/auth';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
 const authService = inject(Auth);

  return next(req).pipe(
    catchError((error) => {
      // Handle session expiration or credential invalidation
      if ([401, 403].includes(error.status)) {
        authService.logout();
      }

      return throwError(() => error);
    })
  );
};
